import store from '@/store';
import { environments } from "../config/configManager";
import { createHttpClient } from './create-http-client';


const logOut = () => {
  store.dispatch('users/doLogout');
  return;
};
const retrieveToken = () => {
  let user = localStorage.getItem('user');
  if (user == 'undefined' || !user) logOut();
  user = JSON.parse(user);

  try {
    store.dispatch('users/refreshToken', {
      token: localStorage.getItem('refreshToken'),
      username: user.username,
    });
  } catch (error) {
    logOut();
  }
};

const client = createHttpClient({
  baseURL: environments.tmed,
  getAuthHeaders: () => {
    const accessToken = localStorage.getItem('token');
    return accessToken ? { Authorization: `${accessToken}` } : {};
  },
  afterSuccess: () => {},
  afterError: ({ status, isNetwork }) => {
    if (isNetwork) return;
    switch (status) {
      case 401:
        retrieveToken();
        break;
      default:
        break;
    }
  },
});
export default client;
